import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  CardBody,
  CardContainer,
  CardHeader,
} from "../../../components/DashboardCard/DashboardCard";
import {
  NavTab,
  NavTabPanel,
  NavTabs,
} from "../../../components/NavTabs/NavTabs";
import { ConfigNavTabs } from "../Program/ProgramConfig";

import BrowserHeader from "../../../components/BrowserHeader/BrowserHeader";

import ThemisRuleList from "./ThemisRuleList";
import ThemisRuleSetList from "./ThemisRuleSetList";

const ThemisSettings = (props: { tab: string }) => {
  const tabs = ["Rules", "Rule Sets"];
  const tabNames = ["Rules", "Rule Sets"];

  const defaultTab = tabs.indexOf(props.tab || "Rules" || "Rule Sets");
  const [tabIndex, setTabIndex] = useState(defaultTab);

  useEffect(() => {
    setTabIndex(defaultTab);
  }, [defaultTab]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tabIndex]);

  return (
    <CardContainer>
      <BrowserHeader title={`Themis: ${tabNames[tabIndex]}`} />
      <CardHeader>
        <h2 className="card-title">Themis Setup</h2>
      </CardHeader>
      <NavTabs
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
      >
        <ConfigNavTabs>
          <NavTab>
            <Link className="no-underline" to="/themis/rules">
              Rules
            </Link>
          </NavTab>
          <NavTab>
            <Link className="no-underline" to="/themis/rulesets">
              Rule Sets
            </Link>
          </NavTab>
        </ConfigNavTabs>
        <NavTabPanel>
          <CardBody>
            <ThemisRuleList />
          </CardBody>
        </NavTabPanel>
        <NavTabPanel>
          <CardBody>
            <ThemisRuleSetList />
          </CardBody>
        </NavTabPanel>
      </NavTabs>
    </CardContainer>
  );
};

export default ThemisSettings;

export interface SettingsModel {
  id?: number;
  paymentThreshold?: number;
  isDemo: boolean;
  featureFlags: { [key: string]: boolean };
}
